import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./take-a-note.css";

const noteArticles = [
  {
    id: "candle-care",
    category: "Candle Care",
    title: "Aetheatia Guidebook",
    // subtitle: "Elevating Your Candle Experience",
    image: "/images/candle-care.png",
    excerpt:
      "Learn how to burn, trim, store, and care for your candles for the best luminous experience.",
  },
  // {
  //   id: "terms",
  //   category: "Terms",
  //   title: "Policies & Terms",
  //   subtitle: "Refund, Shipping, Privacy & Support",
  //   image: "/images/j3.jpg",
  //   excerpt:
  //     "Read Aethearia’s refund, return, exchange, shipping, privacy, and customer support policies.",
  // },
];

export default function TakeANote() {
  const article = noteArticles[0];

  return (
    <>
      <Header />

      <main className="take-note-page">
        <section className="note-detail">
          <div className="note-detail-hero">
            <img src={article.image} alt={article.title} />

           
          </div>

          {article.id === "candle-care" && <CandleCareContent />}
          {article.id === "terms" && <TermsContent />}
        </section>
      </main>

      <Footer />
    </>
  );
}
function CandleCareContent() {
  return (
    <div className="note-content" >
      <h2 className="">Aethearia Guidebook</h2>

      <h3>Let It Burn Evenly</h3>
      <ul>
        <li>
          Let the candle burn for a minimum of 2 hours at the first usage, to
          prevent tunneling and ensure maximum fragrance throw.
        </li>
        <li>
          Allow wax to melt fully to the candle jar edge during the first few
          burns.
        </li>
      </ul>

      <h3>Trim Before Every Burn</h3>
      <ul>
        <li>
          Trim your candle wick to 1/4th of an inch before every use to prevent
          soot, smoking, and uneven burning.
        </li>
      </ul>

      <h3>Burn Responsibly</h3>
      <ul>
        <li>Always burn the candle within sight.</li>
        <li>Never keep the lit candle unattended.</li>
        <li>Keep away from children, pets, curtains, loose clothing, and drafts.</li>
        <li>
          Place on a stable, heat-resistant surface, away from flammable objects.
        </li>
        <li>Do not burn for more than 4 hours at a time.</li>
      </ul>

      <h3>Snuff, Don’t Blow</h3>
      <p>
        Extinguish a lit candle with a snuffer or the lid to reduce smoke and
        preserve the fragrance experience.
      </p>

      <h3>Store With Care</h3>
      <ul>
        <li>Keep in a cool, dry place away from direct sunlight and heat.</li>
        <li>Avoid humid areas to preserve wax and fragrance integrity.</li>
        <li>
          Cover with the lid or dust cap, if provided, to lock in scent and
          prevent dust.
        </li>
        <li>Store candles upright to maintain wick position and shape.</li>
      </ul>

      <blockquote>
        “Each candle is hand-poured with care; store and burn mindfully to enjoy
        its full luminous beauty.”
      </blockquote>

      <h2>For Herbed Rolled Candles</h2>

      <p>
        Each herb-rolled candle is a vessel of intention. Handcrafted with pure
        and natural wax, sacred herbs and gentle energy. As the flame dances, it
        awakens the essence of earth and spirit, guiding your emotions towards
        balance and renewal.
      </p>

      <p>
        Infused with botanicals chosen for their energetic resonance, these
        candles help cleanse, protect and uplift your space. Allow the fragrance
        and warmth to unfold slowly — a quiet ritual that reconnects you to your
        inner rhythm, grounding light within and around you.
      </p>

      <p>Light it with presence and let your intention rise with the flame.</p>

      <h2>Disclaimer</h2>

      <ul>
        <li>
          Aethearia candles, herbs, crystals, and essential oils are thoughtfully
          created to support moments of mindfulness, spiritual rituals, and
          sensory wellbeing. They are not intended to diagnose, treat, cure, or
          replace professional medical advice or treatment. For any health-related
          concerns, please consult a qualified healthcare professional.
        </li>
        <li>
          As our products are handcrafted using natural and mindful ingredients,
          they may naturally respond to seasonal and weather fluctuations — a
          reflection of their artisanal nature. Slight variations in texture,
          appearance, or finish are completely normal. For the best experience,
          please use products within 6 months of receiving and store them in a
          cool, dry place away from direct sunlight. Herb-rolled candles, due to
          their delicate botanical finish, are best enjoyed within 1 month of
          delivery for optimal freshness and appearance.
        </li>
      </ul>
    </div>
  );
}

function TermsContent() {
  return (
    <div className="note-content">
      <h2>Refund, Returns & Exchange Policy</h2>

      <p>
        At Aethearia, every product is handcrafted with care in small batches.
        Due to the handmade and delicate nature of our products, we do not accept
        returns or exchanges for items delivered in perfect condition.
      </p>

      <h3>Order Cancellation</h3>
      <ul>
        <li>Orders can be cancelled only before dispatch.</li>
        <li>Once shipped, cancellations are not possible.</li>
        <li>
          For cancellation requests, please contact us at hello@aethearia.com.
        </li>
      </ul>

      <h3>Damaged, Defective or Incorrect Products</h3>
      <p>
        If your order arrives damaged, defective, or incorrect, please contact us
        within 48 hours of delivery at reachus@aethearia.com with:
      </p>

      <ul>
        <li>Your order number</li>
        <li>Clear photos/videos of the issue</li>
        <li>An unboxing video recorded while opening the parcel</li>
      </ul>

      <p className="note-alert">
        Claims for damaged, missing, or incorrect items may only be considered if
        supported by an unboxing video.
      </p>

      <p>
        Once verified, we will offer a replacement, exchange, store credit, or
        suitable resolution, depending on the case.
      </p>

      <h3>Returns & Exchanges</h3>
      <p>We do not accept returns or exchanges for:</p>

      <ul>
        <li>Change of mind or fragrance preference</li>
        <li>Used, lit, opened, or damaged products after delivery</li>
        <li>Sale, discounted, customized, or limited-edition items</li>
        <li>
          Minor variations in colour, texture, or finish are natural in
          handcrafted products and are not considered defects.
        </li>
      </ul>

      <h3>Refunds</h3>
      <p>
        Approved refunds, if applicable, will be processed to the original
        payment method within 5–10 business days.
      </p>

      <p>For any assistance, write to us at reachus@aethearia.com.</p>

      <hr />

      <h2>FAQ</h2>

      <h3>Can I cancel my order?</h3>
      <p>Yes, only before dispatch.</p>

      <h3>What if my order arrives damaged or incorrect?</h3>
      <p>Please email us within 48 hours with photos/videos and an unboxing video.</p>

      <h3>Can I return a candle if I don’t like the fragrance?</h3>
      <p>
        No, fragrance preference is subjective, so returns are not accepted for
        scent-related concerns.
      </p>

      <h3>Why does my candle look slightly different?</h3>
      <p>
        As our products are handcrafted, slight variations in colour, texture, or
        finish are natural.
      </p>

      <hr />

      <h2>Shipping Policy</h2>

      <p>
        At Aethearia, all our candles are handcrafted and made to order to ensure
        freshness, quality, and attention to detail.
      </p>

      <h3>Order Processing & Dispatch</h3>
      <ul>
        <li>Orders are typically processed within 1–3 business days.</li>
        <li>
          Since each candle is freshly handcrafted, dispatch timelines may vary
          slightly during high-demand periods.
        </li>
        <li>
          Orders placed on weekends or public holidays will be processed on the
          next business day.
        </li>
        <li>
          Once your order is shipped, you will receive a shipping confirmation
          with tracking details via email/SMS/WhatsApp.
        </li>
      </ul>

      <h3>Estimated Delivery Timeline</h3>
      <ul>
        <li>
          Orders are generally delivered within 10–15 business days, depending on
          your location and order volume.
        </li>
        <li>
          Delivery timelines may occasionally vary due to public holidays,
          weather conditions, courier delays, or unforeseen circumstances.
        </li>
        <li>
          If you need your order sooner, contact us on 99755 11512, and we’ll do
          our best to accommodate your request.
        </li>
      </ul>

      <h3>Shipping Charges</h3>
      <ul>
        <li>Free shipping on prepaid orders of ₹2000 and above.</li>
        <li>
          Standard shipping charges may apply to orders below the free shipping
          threshold.
        </li>
        <li>Cash on Delivery may be available at an additional charge.</li>
      </ul>

      <h3>Packaging & Care</h3>
      <p>
        We take utmost care in packaging our products using protective materials
        to ensure they reach you safely. In the rare event of transit damage or
        an incorrect item, please contact us within 48 hours of delivery at
        reachus@aethearia.com, along with photos/videos and an unboxing video of
        the parcel.
      </p>

      <hr />

      <h2>Privacy Policy</h2>

      <p>
        At Aethearia, your privacy is important to us. This Privacy Policy
        explains how we collect, use, store, and protect your personal
        information when you visit our website or make a purchase.
      </p>

      <h3>Information We Collect</h3>
      <p>
        When you interact with Aethearia, we may collect information such as your
        name, email address, phone number, billing and shipping address, IP
        address, and order details.
      </p>

      <h3>Orders & Payments</h3>
      <p>
        Payment details are securely processed through trusted third-party
        payment providers, and Aethearia does not store your complete credit or
        debit card information.
      </p>

      <h3>Customer Support</h3>
      <p>
        When you contact us, we may collect details related to your inquiry,
        order history, and communication records.
      </p>

      <h3>Website Analytics</h3>
      <p>
        We automatically collect certain information about your device and
        browsing activity, including browser type, pages viewed, time spent on
        the website, and referral sources.
      </p>

      <h3>Cookies</h3>
      <p>
        Our website uses cookies and similar technologies to improve
        functionality, remember your preferences, analyse traffic, and
        personalize your experience.
      </p>

      <h3>How We Use Your Information</h3>
      <p>
        We use your information to process orders, fulfil deliveries, communicate
        with you, provide customer support, improve our products and services,
        prevent fraud, and send updates or promotional communications where
        permitted by law.
      </p>

      <h3>Marketing Communications</h3>
      <p>
        With your consent, we may send updates about new collections, exclusive
        offers, and brand news. You may unsubscribe at any time.
      </p>

      <h3>Sharing Information</h3>
      <p>
        We only share your information with trusted service providers necessary
        for operating our business, including payment processors, shipping
        partners, website hosting providers, analytics services, and customer
        support platforms. We do not sell your personal information.
      </p>

      <h3>Data Security</h3>
      <p>
        We implement reasonable administrative, technical, and physical safeguards
        to protect your information from unauthorized access, misuse, disclosure,
        or loss.
      </p>

      <h3>Data Retention</h3>
      <p>
        We retain personal information only for as long as necessary to provide
        our services, comply with legal obligations, resolve disputes, and
        enforce our agreements.
      </p>

      <h3>Your Rights</h3>
      <p>
        Subject to applicable laws, you may request access to, correction of, or
        deletion of your personal information. You may also withdraw consent for
        marketing communications at any time.
      </p>

      <p>To exercise these rights, please contact us at reachus@aethearia.com.</p>

      <h3>Third-Party Services</h3>
      <p>
        Our website may contain links to third-party websites or services.
        Aethearia is not responsible for the privacy practices or content of
        these external websites.
      </p>

      <h3>Policy Updates</h3>
      <p>
        We may update this Privacy Policy from time to time. Any updates will be
        posted on this page with immediate effect.
      </p>

      <h3>Contact Us</h3>
      <p>
        <b>Company Name:</b> Aether Falcon Endevours
        <br />
        <b>Brand Name:</b> Aethearia
        <br />
        <b>Registered Address:</b> H.I.G/B-20, Housing Board Colony, Nagpur,
        Maharashtra – 440022, India
        <br />
        <b>Email:</b> reachus@aethearia.com
        <br />
        <b>Customer Support Hours:</b> Monday – Friday, 10 AM – 6 PM IST
      </p>

      <h3>Governing Law</h3>
      <p>
        This Privacy Policy shall be governed by and interpreted in accordance
        with the laws of India. Any disputes arising from the use of this website
        shall be subject to the jurisdiction of the appropriate courts in India.
      </p>
    </div>
  );
}